import { IWorkflow, IWorkflowState, IWorkflowTransition } from '@/models';
import { InjectionKey, inject, provide } from '@vue/composition-api';
import { MaybeRef, toRef } from '@vueuse/core';

export interface WorkflowFormFieldProvide {
  workflowId: MaybeRef<number>;
  workflowStateId: MaybeRef<number>;
}

export const WorkflowStateThresholdGroupKey: InjectionKey<WorkflowFormFieldProvide> = Symbol.for(
  'workflow:threshold-group-key'
);

type WorkflowProps = {
  workflow: IWorkflow;
  transition: IWorkflowTransition | null;
};

export function provideWorkflowStateThresholdGroup(props: WorkflowProps) {
  const data = {
    workflowId: toRef(() => props.workflow.id!),
    workflowStateId: toRef(
      () => (props.transition?.source_state as IWorkflowState).id
    )
  };
  provide(WorkflowStateThresholdGroupKey, data);

  return data;
}

export function useWorkflowStateThresholdGroup() {
  const data = inject(WorkflowStateThresholdGroupKey);

  if (!data) {
    throw new Error('No context provided for WorkflowStateThresholdGroupKey');
  }

  return data;
}
